<template>
  <div class="ad-page">
    <div>
      <div class="privilege-add">
        <span class="title">权限新增</span>
      </div>
      <div class="privilege-add">
        <span>角色权限</span>
        <el-input placeholder="请输入角色权限" v-model="inputValue"></el-input>
      </div>
      <div class="privilege-add privilege-addRE">
        <span>权限配置</span>
        <div class="tree">
          <el-tree
            :data="data"
            show-checkbox
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            :default-checked-keys="default_checked"
          >
          </el-tree>

          <div class="privilege_game">
            <em>数值权限：</em>
            <div class="ban-checkbox">
              <div
                v-for="(item,key) in fieldList"
                :key="key">
                <em>{{item.label}}:</em>
                <el-checkbox-group v-model="fieldObj" size="small">
                  <el-checkbox
                    v-for="field in item.list"
                    :label="field.route + '&&' + field.key"
                    :key="field.key">隐藏{{field.label}}</el-checkbox>
                </el-checkbox-group>

              </div>
            </div>
          </div>

          <div class="privilege_game">
            <em>游戏权限：</em>
            <div>
              <div class="select-all">
                <span>全选</span>
                <el-switch
                  v-model="selectAllGame"
                  @change="(val) => {
                    if (val) {
                      gamesListCheck = gamesList.map(item => item.id)
                    } else {
                      gamesListCheck = []
                    }
                  }">
                </el-switch>
              </div>
              <el-checkbox-group v-model="gamesListCheck">
                <el-checkbox
                  v-for="(item, i) in gamesList"
                  :key="i"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>

          <div class="privilege_game">
            <em>列表权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="displayList"
                active-text="不展示"
                :active-value="1"
                inactive-text="展示"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>

          <div class="privilege_game">
            <em>所属渠道权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="displayChannel"
                active-text="不展示"
                :active-value="1"
                inactive-text="展示"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>

          <div class="privilege_game">
            <em>所属游戏权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="displayGame"
                active-text="不展示"
                :active-value="1"
                inactive-text="展示"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>
          
          <div class="privilege_game">
            <em>导出权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="canExport"
                active-text="禁止"
                :active-value="1"
                inactive-text="允许"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>

          <div class="privilege_channel">
            <em>渠道包权限：</em>
            <div>
              <div class="select-all">
                <span>全选：</span>

                <el-switch
                  v-model="selectAllChannelPackage"
                  @change="handleSelectAllChannelPackageChange">
                </el-switch>
              </div>
              <div class="filter-conditions">
                <span class="filter-conditions-label">筛选条件：</span>
                <el-select
                  class="filter-channel-group"
                  v-model="channelPackageGroup"
                  multiple
                  filterable
                  placeholder="请选择渠道包组"
                  value-key="id">
                  <el-option
                    v-for="item in channelPackageGroupList"
                    :key="item.id"
                    :label="item.group_name"
                    :value="item">
                  </el-option>
                </el-select>
                <el-input
                  class="filter-channel-search"
                  placeholder="搜索渠道"
                  v-model="searchChannelPackage"
                  clearable>
                </el-input>
                <el-button
                  size="small"
                  class="filter-action-button"
                  @click="clearChannelPackageFilters"
                >清空筛选条件</el-button>
                <el-button
                  size="small"
                  :type="isFilteredChannelPackageAllChecked ? 'warning' : 'primary'"
                  plain
               
                  class="filter-action-button"
                  :disabled="!filteredChannelPackageSelectList.length"
                  @click="toggleFilteredChannelPackages"
                >{{ isFilteredChannelPackageAllChecked ? '取消筛选结果' : '勾选筛选结果' }}</el-button>
              </div>
              <el-checkbox-group v-model="channelPackageListCheck">
                <el-checkbox
                  v-for="(item, i) in filteredChannelPackageSelectList"
                  :key="i"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          
          <!-- <div class="privilege_channel">
            <em>渠道权限：</em>
            <div>
              <div class="select-all">
                <span>全选</span>
                <el-switch
                  v-model="selectAllChannel"
                  @change="(val) => {
                    if (val) {
                      channelListCheck = channelSelectList.map(item => item.id)
                    } else {
                      channelListCheck = []
                    }
                  }">
                </el-switch>
              </div>
              <div v-if="!selectAllChannel" style="margin: 10px 0;">
                <el-select
                  v-model="channelGroup"
                  multiple
                  placeholder="请选择渠道组"
                  value-key="id">
                  <el-option
                    v-for="item in channelGroupList"
                    :key="item.id"
                    :label="item.group_name"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <el-input
                style="margin-bottom: 10px;"
                placeholder="搜索渠道"
                v-model="searchChannel"
                clearable>
              </el-input>
              <el-checkbox-group v-model="channelListCheck">
                <el-checkbox
                  v-for="(item, i) in channelSelectList.filter(item => item.name.includes(searchChannel))"
                  :key="i"
                  :label="item.id"
                  class="channel-checkbox"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div> -->
        </div>
      </div>

      <div class="privilege-submit">
        <el-button type="success" @click="submitBtn()">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";

export default {
  name: "privilegeAdd",
  components: {},
  data() {
    return {
      loadingData: false,
      defaultProps: {
        children: "son",
        label: "name",
      },
      data: [],
      default_checked: [],
      gamesList: [],
      channelSelectList: [],
      gamesListCheck: [],
      channelListCheck: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      inputValue: "",
      fieldObj: [],
      fieldList: {
        'user_role/list': {
          label: '角色列表',
          list: [
            {
              route: "user_role/list",
              key: "amount",
              label: '总充值金额'
            }
          ]
        }
      },
      channelGroupList: [],
      channelGroup: [],
      searchChannel: "",
      displayList: 0,
      displayChannel: 0,
      displayGame: 0,
      canExport: 0,
      // 全选
      selectAllChannel: false,
      selectAllGame: false,
      selectAllChannelPackage: false,
      // 渠道包组
      olderChannelPackageListCheck: [],
      channelPackageListCheck: [],
      channelPackageSelectList: [],
      channelPackageGroupList: [],
      channelPackageGroup: [],
      searchChannelPackage: "",
    };
  },
  computed: {
    ...mapState(["host"]),
    filteredChannelPackageSelectList() {
      const keyword = this.searchChannelPackage || "";
      const selectedGroupIds = new Set(
        this.channelPackageGroup
          .map(group => String(group.group_channel_package_ids || ""))
          .filter(Boolean)
          .join(",")
          .split(",")
          .filter(Boolean)
      );

      return this.channelPackageSelectList.filter(item => {
        const matchesGroup =
          selectedGroupIds.size === 0 || selectedGroupIds.has(String(item.id));
        const matchesKeyword = item.name.includes(keyword);
        return matchesGroup && matchesKeyword;
      });
    },
    filteredChannelPackageIds() {
      return this.filteredChannelPackageSelectList.map(item => item.id);
    },
    isFilteredChannelPackageAllChecked() {
      const checkedIdSet = new Set(this.channelPackageListCheck.map(id => String(id)));
      return (
        this.filteredChannelPackageIds.length > 0 &&
        this.filteredChannelPackageIds.every(id => checkedIdSet.has(String(id)))
      );
    },
  },
  created() {
    this.getGameSelectList();

    // this.getchannelSelectList();
    // this.getChannelGroupList()

    this.getChannelPackageGroupList()
    this.getchannelPackageSelectList()
    this.initializePrivilegeAdd()
  },
  watch: {
    $route(to, from) {
      if (
        to.name === "privilegeAdd" &&
        (!from || to.fullPath !== from.fullPath)
      ) {
        this.initializePrivilegeAdd();
      }
    },
    channelGroup: {
      handler (val, oldVal) {
        if (val.length < oldVal.length) {
          const target = oldVal.filter(item => !val.map(val => val.id).includes(item.id))
          if (target) {
            const arrStr = target.map(c => c.group_channel_ids).toString()
            this.channelListCheck = this.channelListCheck.filter(item => !arrStr.split(',').includes(String(item)))
          }
        } else {
          const arrStr = val.map(c => c.group_channel_ids).toString()
          this.channelListCheck = [...new Set(this.channelListCheck.concat(arrStr.split(',').map(n => Number(n))))]
        }
      }
    },
  },
  methods: {
    initializePrivilegeAdd() {
      this.resetPrivilegeForm();
      if (this.$route.query.copy_id) {
        this.applyCopyPrivilege();
      }
      this.getUsersList();
    },
    resetPrivilegeForm() {
      this.inputValue = "";
      this.data = [];
      this.default_checked = [];
      this.gamesListCheck = [];
      this.channelListCheck = [];
      this.fieldObj = [];
      this.displayList = 0;
      this.displayChannel = 0;
      this.displayGame = 0;
      this.canExport = 0;
      this.selectAllChannel = false;
      this.selectAllGame = false;
      this.selectAllChannelPackage = false;
      this.olderChannelPackageListCheck = [];
      this.channelPackageListCheck = [];
      this.channelPackageGroup = [];
      this.searchChannelPackage = "";

      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCheckedKeys([]);
        }
      });
    },
    parseIdList(value) {
      const values = Array.isArray(value)
        ? value
        : String(value || "").split(",");

      return values
        .filter(item => item !== "")
        .map(item => Number(item))
        .filter(item => !Number.isNaN(item));
    },
    getCopyValue(ids, key, defaultValue = "") {
      if (ids && ids[key] !== undefined && ids[key] !== null) {
        return ids[key];
      }
      const routeValue = this.$route.query[key];
      return routeValue !== undefined && routeValue !== null
        ? routeValue
        : defaultValue;
    },
    applyCopyPrivilege(ids = {}) {
      this.default_checked = this.parseIdList(
        this.getCopyValue(ids, "menu_ids")
      );
      this.gamesListCheck = this.parseIdList(
        this.getCopyValue(ids, "game_ids")
      );
      this.channelListCheck = this.parseIdList(
        this.getCopyValue(ids, "channel_ids")
      );
      this.channelPackageListCheck = this.parseIdList(
        this.getCopyValue(ids, "game_channel_package_ids")
      );
      this.displayList = Number(this.getCopyValue(ids, "display_list", 0));
      this.displayChannel = Number(
        this.getCopyValue(ids, "display_channel", 0)
      );
      this.displayGame = Number(this.getCopyValue(ids, "display_game", 0));
      this.canExport = Number(this.getCopyValue(ids, "export", 0));

      const jsonfield = this.getCopyValue(ids, "field");
      if (jsonfield) {
        try {
          const field = typeof jsonfield === "string"
            ? JSON.parse(jsonfield)
            : jsonfield;
          this.fieldObj = Object.keys(field).map(
            key => key + "&&" + field[key]
          );
        } catch (error) {
          this.fieldObj = [];
        }
      }

      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCheckedKeys(this.default_checked);
        }
        this.updateSelectAllGameState();
        this.updateSelectAllChannelPackageState();
      });
    },
    updateSelectAllGameState() {
      const checkedIdSet = new Set(
        this.gamesListCheck.map(id => String(id))
      );
      this.selectAllGame =
        this.gamesList.length > 0 &&
        this.gamesList.every(item => checkedIdSet.has(String(item.id)));
    },
    handleSelectAllChannelPackageChange(val) {
      if (val) {
        this.olderChannelPackageListCheck = this.channelPackageListCheck;
        this.channelPackageListCheck = this.channelPackageSelectList.map(item => item.id);
      } else {
        this.channelPackageListCheck = [];
        this.olderChannelPackageListCheck = [];
      }
    },
    updateSelectAllChannelPackageState() {
      const allIds = this.channelPackageSelectList.map(item => item.id);
      const checkedIdSet = new Set(this.channelPackageListCheck.map(id => String(id)));
      this.selectAllChannelPackage =
        allIds.length > 0 &&
        allIds.every(id => checkedIdSet.has(String(id)));
    },
    selectFilteredChannelPackages() {
      const checkedList = [...this.channelPackageListCheck];
      const checkedIdSet = new Set(checkedList.map(id => String(id)));
      this.filteredChannelPackageIds.forEach(id => {
        if (!checkedIdSet.has(String(id))) {
          checkedList.push(id);
          checkedIdSet.add(String(id));
        }
      });
      this.channelPackageListCheck = checkedList;
      this.updateSelectAllChannelPackageState();
    },
    unselectFilteredChannelPackages() {
      const filteredIds = new Set(this.filteredChannelPackageIds.map(id => String(id)));
      this.channelPackageListCheck = this.channelPackageListCheck.filter(
        id => !filteredIds.has(String(id))
      );
      this.updateSelectAllChannelPackageState();
      this.olderChannelPackageListCheck = this.channelPackageListCheck;
    },
    toggleFilteredChannelPackages() {
      if (this.isFilteredChannelPackageAllChecked) {
        this.unselectFilteredChannelPackages();
      } else {
        this.selectFilteredChannelPackages();
      }
    },
    clearChannelPackageFilters() {
      this.channelPackageGroup = [];
      this.searchChannelPackage = "";
    },
    // 游戏权限
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
        this.updateSelectAllGameState();
      });
    },
    // 渠道权限
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectList = res.data.data;
      });
    },

    // 新增提交
    submitBtn() {
      // let treeCheck = this.$refs.tree;
      // let array = treeCheck.getCheckedKeys().concat(treeCheck.getHalfCheckedKeys())

      // let treeChecked = treeCheck.toString();
      // let arrayTree = array.toString()
      // let arrayTree = this.$refs.tree.getCheckedKeys().toString()
      let treeCheck = this.$refs.tree;
      let treeChecked = treeCheck
        .getCheckedKeys()
        .concat(treeCheck.getHalfCheckedKeys());
      let arrayTree = treeChecked.map((item) => {
        return item;
      });

      let gamesListChecked = this.gamesListCheck.toString();
      let channelListChecked = this.channelListCheck.toString();
      let channelPackageListChecked = this.channelPackageListCheck.toString();

      const params = {
        role_name: this.inputValue,
        menu_ids: arrayTree.toString(),
        game_ids: gamesListChecked,
        channel_ids: channelListChecked,
        display_list: this.displayList,
        display_channel: this.displayChannel,
        display_game: this.displayGame,
        export: this.canExport,
        game_channel_package_ids: channelPackageListChecked,
      }
      if (this.fieldObj?.length) {
        const field = {}
        this.fieldObj.forEach(f => {
          const [key, value] = f.split('&&')
          field[key] = value
        })
        params.field = JSON.stringify(field)
      }

      fetch({
        url: "/admin/admin_privileges/privilege_create",
        method: "POST",
        data:params,
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "新增成功！",
          });
          this.$router.push({ name: "privilegeList" });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示员工管理列表数据
    getUsersList() {
      const copyId = this.$route.query.copy_id;
      this.loadingData = true;
      fetch({
        url: "/admin/admin_privileges/privilege_create",
        method: "POST",
        data: {},
      })
        .then((res) => {
          if (res.data.status) {
            this.data = res.data.data;
            if (copyId) {
              this.applyCopyPrivilege();
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    // 展示渠道列表数据
    getChannelGroupList() {
      fetch({
        url: "/admin/channel_groups/list",
        method: "GET",
        params: {
          per_page: 100,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.channelGroupList = res.data.data.data;
          }
        })
    },
    
    // 展示渠道包组列表数据
    getChannelPackageGroupList() {
      fetch({
        url: "/admin/channel_package_group/list",
        method: "GET",
        params: {
          per_page: 100,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.channelPackageGroupList = res.data.data.data;
          }
        })
    },

    // 渠道包组权限
    getchannelPackageSelectList() {
      fetch({
        url: "/admin/game_channel_packages/channel_package_select",
        method: "GET",
      }).then((res) => {
        this.channelPackageSelectList = res.data.data;
        this.updateSelectAllChannelPackageState();
      });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.privilege-add {
  display: flex;
  align-items: center;
  padding-bottom: 30px;
  .title {
    font-size: 24px;
  }
  .el-input {
    width: 280px;
  }
}
.privilege-add > span {
  display: block;
  margin-right: 10px;
}
.privilege-addRE {
  align-items: flex-start;
  padding-bottom: 0;
  .tree {
    flex: 1;
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
}

.privilege_game,
.privilege_channel {
  margin: 20px 0;
  display: flex;
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  em {
    display: inline-block;
    min-width: 90px;
    font-style: normal;
    position: relative;
    top: -2px;
    font-size: 14px;
    white-space: nowrap;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    min-width: 200px;
    padding: 5px;
  }
}
.channel-checkbox {
  flex: 0 0 30%;
}
.privilege_game {
  .el-checkbox {
    width: 200px;
  }
}
.privilege_game > div,
.privilege_channel > div {
  margin-left: 10px;
}
.privilege-submit {
  text-align: right;
  margin: 20px 0;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgba(0, 0, 0, 0.9);
}
.ban-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #d7d8d9;
  border-color: #DCDFE6;
}
.select-all {
  display: flex;
  font-size: 14px;
  align-items: center;
}
.filter-conditions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
  flex-wrap: nowrap;
}
.filter-conditions-label {
  flex: 0 0 auto;
  color: inherit;
  white-space: nowrap;
}
.filter-channel-group,
.filter-channel-search {
  width: 280px;
}
.filter-action-button {
  min-width: 130px;
  height: 36px;
  padding: 0 16px;
  font-size: 14px;
}
</style>
